// 更新用户信息
export const updateUserInfo = (gradeNum, totalScore, examId) => {
  // 同步用户年级和 用户分数
  let score = '';
  let grade;
  if (gradeNum === 2 || gradeNum === 21 || gradeNum === 22 || gradeNum === 23) {
    grade = '初中';
  } else if (gradeNum === 3) {
    grade = '高一';
  } else if (gradeNum === 31) {
    grade = '高一';
  } else if (gradeNum === 32) {
    grade = '高二';
  } else if (gradeNum === 33) {
    grade = '高三';
  } else if (gradeNum === 4 || gradeNum === 41) {
    grade = '大一';
  } else if (gradeNum === 42) {
    grade = '大二';
  } else if (gradeNum === 43) {
    grade = '大三';
  } else if (gradeNum === 44 || examId === 1) {
    grade = '大四';
  } else {
    grade = '大三';
  }
  if (examId === 1) {
    if (grade === '初中') {
      score = '';
    } else if (grade === '高一' && totalScore >= 0 && totalScore <= 59) {
      score = '0-59分';
    } else if (grade === '高一' && totalScore >= 60) {
      score = '60-92分';
    } else if ((grade === '高二' || grade === '高三') && totalScore >= 0 && totalScore <= 89) {
      score = '0-89分';
    } else if ((grade === '高二' || grade === '高三') && totalScore >= 90) {
      score = '90-92分';
    } else if (grade === '大一' || grade === '大二') {
      score = '0-92分';
    } else if (grade === '大三' && totalScore >= 0 && totalScore <= 59) {
      score = '0-59分';
    } else if (grade === '大三' && totalScore >= 60 && totalScore <= 79) {
      score = '60-79分';
    } else if (grade === '大三' && totalScore >= 80) {
      score = '80-92分';
    } else if (totalScore >= 0 && totalScore <= 79) {
      score = '0-79分';
    } else if (totalScore >= 80 && totalScore <= 92) {
      score = '80-92分';
    }
  } else if (grade === '初中') {
    score = '2.0-7.0';
  } else if ((grade === '高一' || grade === '高二' || grade === '高三') && totalScore >= 2.0 && totalScore <= 5.0) {
    score = '2.0-5.0';
  } else if ((grade === '高一' || grade === '高二' || grade === '高三') && totalScore >= 5.5 && totalScore <= 6.0) {
    score = '5.5-6.0分';
  } else if ((grade === '高一' || grade === '高二' || grade === '高三') && totalScore >= 6.5) {
    score = '6.5-7.0';
  } else if (grade === '大一' || grade === '大二') {
    score = '2.0-7.0';
  }
  return { score, grade };
};

// 计算正确率(填空题的每个空格按照权重记分)
export const countAccuracy = value => {
  const { correct, count, blank } = value;
  let accuracy; // 正确率
  if (!blank || (blank && blank.length <= 0)) {
    accuracy = correct / count;
  } else {
    const weight = 1 / (count + blank.length); // 权重
    // 计算填空题正确率之和
    let blankAccuracy = 0;
    blank.forEach(item => {
      blankAccuracy += item.correct / item.count;
    });
    accuracy = blankAccuracy + correct * weight;
  }
  return accuracy;
};

// 雅思口语 30分制 转 9分制
export const ieltsSpeakingChange = score => {
  if (score <= 0) {
    return 0;
  } else if (score >= 1 && score <= 15) {
    return 4;
  } else if (score >= 16 && score <= 19) {
    return 5;
  } else if (score >= 20 && score <= 23) {
    return 6;
  }
};

// 处理阅读与听力能力标签
export const handleLables = (labels, isFull) =>
  labels.map(item => {
    let accuracy;
    // 完整版入学测评需要
    if (isFull === true) {
      item.accuracy = countAccuracy(item) >= 0.9 ? 0.9 :  // eslint-disable-line
        (countAccuracy(item) <= 0.1 ? 0.1 : countAccuracy(item)); // eslint-disable-line
    } else {
      accuracy = item.correct / item.count;
      item.accuracy = (accuracy >= 0.76) ? 0.76 : accuracy; // eslint-disable-line
    }
    if (accuracy < 0.5) {
      item.grade = 1;    // eslint-disable-line
    } else if (accuracy < 0.7 && accuracy >= 0.5) {
      item.grade = 2;   // eslint-disable-line
    } else {
      item.grade = 3;  // eslint-disable-line
    }
    return item;
  });

// 处理口语与写作的能力标签
export const handleLables2 = (labels, examId = 1, type, isFull) =>
  labels.map(item => {
    let accuracy;
    let score;
    if (isFull && type === 'writing') {
      accuracy = countAccuracy(item);
      if (examId === 2) {
        accuracy = accuracy === 1 ? 0.67 : (accuracy >= 0.5 && accuracy < 1 ? 0.56 : 0.44);
      } else if (item.name === '主题把握' || item.name === '细节转述') {
        accuracy = accuracy === 1 ? 0.7 : (accuracy >= 0.5 && accuracy < 1 ? 0.5 : 0.27);
      } else if (item.name === '阅读与听力语料分析') {
        accuracy = accuracy === 1 ? 0.67 : (accuracy >= 0.6 && accuracy < 1 ?
          0.53 : (accuracy >= 0.2 && accuracy < 0.6 ? 0.4 : 0.27));
      }
    } else if (isFull && type === 'speaking') {
      accuracy = countAccuracy(item);
      if (item.name === '发音准确度') {
        accuracy = accuracy === 1 ? 0.67 : (accuracy >= 0.5 && accuracy < 1 ? 0.56 : 0.44);
      } else if (item.name === '阅读与听力语料分析') {
        accuracy = accuracy === 1 ? 0.7 : (accuracy >= 0.83 && accuracy < 1 ?
          0.6 : (accuracy >= 0.5 && accuracy < 0.83 ? 0.5 :
            (accuracy >= 0.15 && accuracy < 0.5 ? 0.4 : 0.27)));
      }
    } else if (item.name === '发音准确度') {
      accuracy = (item.correct / item.count) >= 0.55 ? 0.55 : item.correct / item.count;
    } else {
      accuracy = (item.correct / item.count) >= 0.7 ? 0.7 : item.correct / item.count;
    }
    if (examId === 1) {
      score = 30 * accuracy;
    } else {
      score = 9 * accuracy;
    }
    // 对score分数 进行处理
    item.score = Math.round(score * 2) / 2;  // eslint-disable-line
    item.accuracy = accuracy; // eslint-disable-line
    return item;
  });

// 计算机批返回的结果
export const countScore = (examId, type, machineResult) => {
  let score = 0;
  let totalScore = 0;
  machineResult.forEach(item => {
    if (examId === 1) {
      if (type === 'speaking') {
        totalScore += (item.score) <= 23 ? (item.score) : 23;
      } else {
        totalScore += (item.score * 30 + 5) <= 23 ? (item.score * 30 + 5) : 23;
      }
    } else if (type === 'speaking') {
      totalScore += ieltsSpeakingChange(item.score) <= 6 ?
        ieltsSpeakingChange(item.score) : 6;
    } else {
      totalScore += (item.score * 9 + 2) <= 6 ? (item.score * 9 + 2) : 6;
    }
  });
  if (examId === 1) {
    score = Math.round(totalScore / machineResult.length >= 0 ? totalScore
      / machineResult.length : 0);
  } else {
    score = totalScore / machineResult.length >= 0 ? totalScore / machineResult.length : 0;
    score = Math.ceil(2 * score) / 2;
  }
  return score;
};




// WEBPACK FOOTER //
// ./src/components/report/evaluation_report/utils.js